import {
	NO_CATEGORY,
	type ItsmPractice,
} from '@atlassian/jira-servicedesk-work-category/src/common/constants.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { type Action, createStore, createHook } from '@atlassian/react-sweet-state';
import { HIDDEN, VISIBLE } from './constants.tsx';
import type { State } from './types.tsx';

const actions = {
	showManageQueuesDialog:
		(): Action<State> =>
		({ setState }) => {
			setState({
				manageQueuesDialogStatus: VISIBLE,
			});
		},
	hideManageQueuesDialog:
		(): Action<State> =>
		({ setState }) => {
			setState({
				manageQueuesDialogStatus: HIDDEN,
				filterQueuesSearchQuery: '',
			});
		},
	setFilterQueuesSearchQuery:
		(query: string): Action<State> =>
		({ setState }) => {
			setState({
				filterQueuesSearchQuery: query,
			});
		},
	setRendered:
		(projectKey: string, category: ItsmPractice): Action<State> =>
		({ setState }) => {
			setState({
				renderedInProject: projectKey,
				renderedInCategory: category,
			});
		},
} as const;

type Actions = typeof actions;

const initialState: State = {
	manageQueuesDialogStatus: HIDDEN,
	filterQueuesSearchQuery: '',
	renderedInProject: '',
	renderedInCategory: NO_CATEGORY,
};

const Store = createStore<State, Actions>({
	name: 'manage-queues-jsm',
	initialState,
	actions,
});

const getIsDialogVisible = (state: State): boolean => state.manageQueuesDialogStatus === VISIBLE;

export const useIsManageQueuesDialogVisible = createHook(Store, {
	selector: getIsDialogVisible,
});

export const useManageQueuesDialog = createHook(Store);
